import { useMonthlyLeaderboardReset } from "@/src/services/api/leaderboard/leaderboard.hooks";

/**
 * Headless gate that fires the once-per-month leaderboard reset on app launch.
 * Mounted by AuthProvider once the user is signed in; `orgId` drives a re-check
 * when the active org changes (account/org switch). Renders nothing.
 */
export default function LeaderboardSeasonGate({ orgId }: { orgId: string }) {
  useMonthlyLeaderboardReset(orgId);
  return null;
}
